import {Component, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {PlayerSessionService} from '../../../service/player-session.service';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {ViewService} from '../../../../shared/service/view.service';
import {PlayerProfileService} from '../../../service/player-profile.service';
import {RestErrorHelper} from '../../../../../helper/rest-error-helper';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {PLAYER_PREFIX_FULL} from '../../../player.routes';
import {Tab, TabList, Tabs} from 'primeng/tabs';
import {MenuItem} from 'primeng/api';
import {CdkCopyToClipboard} from '@angular/cdk/clipboard';
import {PlayerProfile} from '../../../model/player-profile';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {
  PlayerProfileSettingsDialogComponent
} from '../../player-profile-settings-dialog/player-profile-settings-dialog.component';
import {DialogService} from 'primeng/dynamicdialog';
import {
  PlayerProfileHelpDialogComponent
} from '../../player-profile/player-profile-help/player-profile-help-dialog/player-profile-help-dialog.component';
import {environment} from '../../../../../../environments/environment';
import {FrontendNotificationService} from '../../../../frontend/service/frontend-notification.service';

@Component({
  selector: 'app-player-profile-overview-header',
  imports: [
    TranslatePipe,
    Button,
    Tooltip,
    Tab,
    TabList,
    Tabs,
    RouterLink,
    CdkCopyToClipboard
  ],
  templateUrl: './player-profile-overview-header.component.html',
  styleUrl: './player-profile-overview-header.component.scss'
})
export class PlayerProfileOverviewHeaderComponent implements OnInit, OnDestroy
{
  public view = inject(ViewService);
  private playerSessionService = inject(PlayerSessionService);
  private playerProfileService = inject(PlayerProfileService);
  public restErrorHelper = inject(RestErrorHelper);
  private router = inject(Router);
  private translate = inject(TranslateService);
  private dialogService = inject(DialogService);
  private frontendNotificationService = inject(FrontendNotificationService);

  @ViewChild('tabList') tabList: TabList;

  showSystem: boolean;
  system = this.frontendNotificationService.system;
  isLoggingOut: boolean;
  menuHidden: boolean;
  playerProfile: PlayerProfile;

  items: MenuItem[];
  selectedTabValue: number;
  activatedRouteSubscription: Subscription;

  ngOnInit(): void
  {
    this.showSystem = environment.local || environment.test2k;
    this.menuHidden = this.playerSessionService.settingMenuHidden;
    this.playerProfile = this.playerSessionService.playerProfileObject;
    this.initTabItems();

    this.activatedRouteSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() =>
    {
      this.routeChanged();
    });
  }

  ngOnDestroy(): void
  {
    this.activatedRouteSubscription?.unsubscribe();
  }

  private routeChanged(): void
  {
    // console.log('Route changed: ', this.router.url, this.items);
    if (this.items && this.router.url)
    {
      for (const item of this.items)
      {
        // console.log('Prüfe ' + item.routerLink + ' mit ' + this.router.url + ', Value: ' + item.value + ', selectedTabValue: ' + this.selectedTabValue);
        if (this.router.url.includes('/' + item.routerLink))
        {
          if (this.selectedTabValue !== item.value)
          {
            console.log('Tab Index changed: ' + item.value);
            this.selectedTabValue = item.value;
            // TabHelper.updateInkbarTabList(this.tabList);
          }
        }
      }
    }
  }

  private initTabItems(): void
  {
    const currentUrl = this.router.url;
    console.log('initTabItems, currentUrl: ' + currentUrl);

    this.items = [
      {value: 0, label: 'PLAYER_PROFILE', routerLink: 'dashboard', icon: 'pi pi-home'},
      {value: 1, label: 'MESSAGES', routerLink: 'messages', icon: 'pi pi-envelope'},
      {value: 2, label: 'CALENDAR', routerLink: 'calendar', icon: 'pi pi-calendar'},
      {value: 3, label: (this.view.isMobile ? 'STATISTICS_ABBR' : 'STATISTICS'), routerLink: 'statistics', icon: 'pi pi-chart-line'},
      // {value: 2, label: 'ACHIEVEMENTS', routerLink: 'achievements'},
      {value: 4, label: 'ACCOUNT', routerLink: 'account', icon: 'pi pi-user'}
    ];

    for (const item of this.items)
    {
      if (currentUrl.includes('/' + item.routerLink))
        this.selectedTabValue = item.value;
    }
    if (!(this.selectedTabValue >= 0))
      this.selectedTabValue = 0;
  }

  public logout(): void
  {
    this.isLoggingOut = true;
    this.playerProfileService.logout().subscribe({
      next: () =>
      {
        this.isLoggingOut = false;
        this.router.navigate([PLAYER_PREFIX_FULL + '/register']).then(() => {});
      },
      error: error =>
      {
        this.isLoggingOut = false;
        this.restErrorHelper.handleErrorService(error);
        this.playerProfileService.playerAuthenticationService.logoutSuccess();
      }
    });
  }

  public openSettings(): void
  {
    PlayerProfileSettingsDialogComponent.openDialog(this.dialogService, this.translate);
  }

  public openHelp(): void
  {
    PlayerProfileHelpDialogComponent.openDialog(this.dialogService, this.translate);
  }

  public hideMenu(): void
  {
    this.playerSessionService.setSettingMenuHidden(true, true);
    this.menuHidden = true;
  }

  public showMenu(): void
  {
    this.playerSessionService.setSettingMenuHidden(false, true);
    this.menuHidden = false;
  }
}
